<template>
  <div class="loading-wrapper">
    <div class="inner">
      <img src="../assets/img/loading.gif"
           alt="" />
      <p>加载中，请稍后...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss">
.loading-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000b1f;
  .inner {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 13vw;
    }
    p {
      width: 100%;
      font-size: 3vw;
      color: #fff;
      text-align: center;
      line-height: 1.4;
    }
  }
}
</style>
